export default "__VITE_ASSET__B9s$u7MS__"